import { useContext } from "react";
import { Box, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";
import { ScreenContext } from "../context/ScreenContext";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const ServiceItem = ({ data = [] }) => {
  const { isMobile } = useContext(ScreenContext);

  const navigate = useNavigate();

  const location = useLocation();

  const handleWhatsApp = (title) => {
    trackEvent(`${title}_whatsapp`, {
      page_path: location.pathname,
      page_url: window.location.href,
      section: `${title}_WhatsApp`,
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "525959570961",
      `Hola Centro Médico MEDAM 👋, me gustaría recibir información sobre ${title}.`,
      true,
    );
  };

  return (
    <Grid container>
      <Grid size={design.gridOne} />
      <Grid container size={design.grid10}>
        <CustomText
          color="#782A9F"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          width="100%"
          sx={design.textNuestro}
        >
          Nuestros Servicios
        </CustomText>

        <CustomText
          color="#3A3A3A"
          fontWeight={400}
          fontFamily="Nunito"
          textAlign="justify"
          sx={design.textCentro}
        >
          En Centro Médico MEDAM, tu salud y la de tu familia son lo más
          importante. Nuestro compromiso es ofrecerte atención médica con
          profesionalismo, cercanía y calidad humana. Sabemos que cada paciente
          es único, por eso te acompañamos en cada paso, asegurándonos de que
          recibas la atención que mereces, siempre con empatía, calidez y
          dedicación.
        </CustomText>

        {data.map((service) => (
          <Grid key={service?.title} size={design.grid4} mb={4}>
            <Box sx={design.Card}>
              {/* Imagen */}
              <Box sx={design.ImageContainer}>
                <ImageLoader
                  src={service?.image}
                  alt={service?.title}
                  width="100%"
                  height={isMobile ? 240 : 250}
                  style={design.Image}
                />
                <Box sx={design.Gradient} />
                <CustomText
                  variant="subtitle1"
                  color={service?.color}
                  fontWeight={700}
                  fontFamily="Nunito"
                  sx={design.Title}
                >
                  {service?.title}
                </CustomText>
              </Box>
              {/* Contenido */}
              <Box sx={design.Content}>
                <CustomText
                  variant="subtitle1"
                  color="#606060"
                  mb={2}
                  fontFamily="Nunito"
                  textAlign="justify"
                  width="100%"
                  sx={design.Description}
                >
                  {service?.description}
                </CustomText>

                <Grid container sx={design.Actions}>
                  <CustomButton
                    width={"95%"}
                    height={40}
                    borderRadius={10}
                    backgroundColor="#65B12E"
                    colorTexto="#FFF"
                    fontFamily="Nunito"
                    fontSize={14}
                    variant="contained"
                    grid={6}
                    gridXS={12}
                    onClick={() => handleWhatsApp(service?.title)}
                  >
                    WhatsApp
                  </CustomButton>
                  <CustomButton
                    width={"95%"}
                    height={40}
                    borderRadius={10}
                    backgroundColor="#FFF"
                    colorTexto="#00518c"
                    border="1px solid #c2c2c2"
                    fontFamily="Nunito"
                    fontSize={14}
                    variant="contained"
                    grid={6}
                    gridXS={12}
                    onClick={() => navigate("/directorioMedico")}
                  >
                    Conoce más
                  </CustomButton>
                </Grid>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid size={design.gridOne} />
    </Grid>
  );
};

export default ServiceItem;

const design = {
  Card: {
    width: "90%",
    height: "100%",
    borderRadius: "24px",
    overflow: "hidden",
    backgroundColor: "#FFF",
    boxShadow: "0 12px 35px rgba(0,0,0,.08)",
    transition: "all .35s ease",
    display: "flex",
    flexDirection: "column",
    "&:hover img": {
      transform: "scale(1.08)",
    },
  },
  ImageContainer: {
    position: "relative",
    overflow: "hidden",
    height: {
      xs: 240,
      md: 250,
    },
  },
  Image: {
    objectFit: "cover",
    transition: "transform .4s ease",
  },
  Gradient: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: "45%",
    background:
      "linear-gradient(to top, rgba(255,255,255,.98) 0%, rgba(255,255,255,.75) 30%, rgba(255,255,255,0) 100%)",
  },
  Title: {
    position: "absolute",
    bottom: 20,
    left: 20,
    fontSize: {
      xs: 24,
      md: 28,
    },
    lineHeight: 1.1,
  },
  Content: {
    padding: {
      xs: "0px 24px",
      md: "0px 30px",
    },
  },
  Description: {
    fontSize: {
      xs: 16,
      md: 15,
    },
    lineHeight: "24px",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 7,
    overflow: "hidden",
    textOverflow: "ellipsis",
    minHeight: {
      xs: "auto",
      md: 168, // 24px * 7 líneas
    },
  },
  Actions: {
    py: 1,
    marginTop: 1,
    borderTop: "1px solid #E0E0E0",
  },
  textCentro: {
    fontSize: {
      xs: 24,
      md: 20,
    },
    pr: 5,
    pb: 3,
  },
  textNuestro: {
    marginY: 3,
    fontSize: {
      xs: 24,
      md: 40,
    },
  },
  gridOne: { xs: 1, sm: 1, lg: 1 },
  grid10: { xs: 10, sm: 10, lg: 10 },
  grid4: { xs: 12, sm: 6, lg: 4 },
};
